// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bevmMainnet as _bevmMainnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bevmMainnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11501
 * Chain Name: BEVM Mainnet
 * Default Block Explorer: https://scan-mainnet.bevm.io
 * Default RPC URL: https://rpc-mainnet-1.bevm.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bevmMainnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bevmMainnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bevmMainnet = createCommon({
	..._bevmMainnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
